<template>
  <v-dialog max-width="900" persistent>
    <v-card>
      <v-card-title
        class="primary white--text d-flex justify-space-between py-3"
      >
        <v-icon
          class="white--text"
          @click="
            () => {
              $emit('close');
            }
          "
          >{{ $t("ic.close") }}
        </v-icon>
      </v-card-title>
      <v-card-text class="reportTblByMajor elevation-2 py-2 pt-5">
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "PopupReportTblByMajor",
  props: {
    reportByMajorResquest: {
      type: Object,
      required: true,
    },
  },
  data() {},
};
</script>

<style scoped lang="scss">
.reportTblByMajor {
  overflow: auto;
  max-height: calc(100vh - 300px);

  .pre--line {
    white-space: pre-line !important;
  }
}
</style>
